const updateZones = (state, payload) => {
  state.zones = payload
}

const updateThresholds = (state, payload) => {
  state.savedThresholdSettings = payload
}

const resetAZList = (state) => {
  state.activityZoneListData = null
}

const updateAZListData = (state, payload) => {
  state.activityZoneListData = payload
}

const updateAZPagination = (state, payload) => {
  state.activityZonePagination = payload
}

const updateSelectedZone = (state, payload) => {
  state.selectedZone = payload
}

const updateSignalStrengths = (state, payload) => {
  state.signalStrengths = payload
}

export default {
  updateZones,
  updateThresholds,
  updateAZListData,
  updateAZPagination,
  resetAZList,
  updateSelectedZone,
  updateSignalStrengths,
}
